<script setup lang="ts">
import { HOME_PATH } from '@/constants'
import { LogoWithText } from '@/shared'
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarInset,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarProvider,
} from '@/ui'

import { HeaderInset, SidebarNavMenu, UserMenu } from './components'
</script>

<template>
  <SidebarProvider class="bg-slate-50">
    <Sidebar class="border-r" collapsible="icon">
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg">
              <LogoWithText
                :path="HOME_PATH"
                wrapper-classes="gap-x-2"
                icon-wrapper-classes="size-8"
                icon-classes="size-3"
                text-wrapper-classes="flex-1 text-sm"
              />
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <SidebarNavMenu />
      </SidebarContent>
      <SidebarFooter>
        <SidebarMenu>
          <SidebarMenuItem>
            <UserMenu />
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarFooter>
    </Sidebar>
    <SidebarInset class="overflow-hidden bg-slate-50">
      <HeaderInset class="z-50 border-b bg-white" />
      <slot />
    </SidebarInset>
  </SidebarProvider>
</template>
